import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { included, purchaseUrl } from '../data/content';
import { Countdown } from './ui/Countdown';
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="scroll-mt-24 bg-canvas px-4 py-14 md:py-16" aria-labelledby={`${id}-title`} data-id="element-202" data-mp="3ns5xfgnswo5p">
      <div className="mx-auto max-w-2xl text-center" data-id="element-203" data-mp="kaw04ugoiadb">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-primary md:text-sm" data-id="element-204" data-mp="k9kuep3oasjk">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-205" data-mp="ac6tjxu8gccd">
          <Countdown data-id="element-206" data-mp="abeweikzm6jz" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-207" data-mp="aekmo15creha">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-208" data-mp="2v407mfhw48z0" />
          Después sube $6.990 ARS. No vuelve.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-primary bg-white p-6 text-left shadow-[0_24px_60px_rgba(10,29,56,.20)] md:p-9" data-id="element-209" data-mp="2fodqdd3re4r7">
          <div className="text-center" data-id="element-210" data-mp="2aquegjuja42f">
            <span className="inline-flex rounded-full bg-accent px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-ink" data-id="element-211" data-mp="2ooivthpe6t2q">
              🔥 Precio especial de lanzamiento
            </span>
            <h2 id={`${id}-title`} className="mt-4 text-xl font-black text-ink md:text-3xl" data-id="element-212" data-mp="2ylez990fop0f">
              Acceso a los 6 tomos + 5 bonos GRATIS
            </h2>
          </div>

          <ul className="my-7 space-y-2.5 border-y border-line py-6" data-id="element-213" data-mp="38crqbyeerb5e">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-slate-700" data-id="element-214" data-mp="33cx07x2giple">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-215" data-mp="3hc6cilnjkzk3" />
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-216" data-mp="3cbs8dep2a9rc">
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-217" data-mp="2a18d2a4tv843">
              Antes
            </p>
            <p className="mt-1 text-2xl font-black text-slate-400 line-through" data-id="element-218" data-mp="2f01rq5vup55u">$78.940 ARS</p>
            <p className="mt-1 text-xs font-semibold text-slate-500" data-id="element-219" data-mp="2j0byvlvdq1ma">
              Valor individual de los 6 tomos y los 5 bonos
            </p>
          </div>

          <div className="mt-6 text-center" data-id="element-220" data-mp="2srgbiexl1ady">
            <p className="inline-flex rounded-full bg-accent px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-ink" data-id="element-221" data-mp="2sqexq2p6m9sj">
              75% de descuento · ahorrás $58.950 ARS
            </p>
            <div className="mt-6" data-id="element-222" data-mp="32pmbgqztw6g6">
              <motion.a href={purchaseUrl} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.012
            }} whileTap={{
              scale: 0.988
            }} transition={{
              duration: 0.14,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex w-full flex-col items-center gap-1 rounded-2xl border border-accent/60 bg-primary px-6 py-5 text-center shadow-[0_18px_38px_rgba(10,29,56,.28)] transition-colors duration-150 ease-out hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-accent/30" data-id="element-223" data-mp="36qpqjba1xygc">
                <span className="text-[11px] font-extrabold uppercase tracking-[.16em] text-accent" data-id="element-224" data-mp="r210uurqljm9">
                  Hoy · precio de lanzamiento
                </span>
                <span className="text-3xl font-black leading-none text-white md:text-5xl" data-id="element-225" data-mp="1npxk67ek6t16">
                  $19.990 ARS
                </span>
                <span className="mt-1 text-sm font-extrabold uppercase tracking-wide text-white md:text-base" data-id="element-226" data-mp="1eqtycvo0bziz">
                  💪 Quiero mi Combo Hipertrofia ahora →
                </span>
              </motion.a>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-500" data-id="element-227" data-mp="3cycz56ieujb">
              <span className="flex items-center gap-1" data-id="element-228" data-mp="3ukuaiwhe9ob5">
                <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-229" data-mp="1m8zzrwachyyk" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-230" data-mp="1r19tlnekzj64">
                <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-231" data-mp="1d9d8i3bby9j8" /> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-232" data-mp="1ha6v8td1diaj">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-233" data-mp="1h8m0p3qq1zco" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-234" data-mp="24ygcrj37vjvv">
                <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-235" data-mp="29yb05cns9rc6" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}